module.exports = __webpack_public_path__ + "img/phone_qr.262cc3e4.png";